import AssetService from '@/lib/Asset';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useAssetInfo(symbol: string) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['assetInfo', symbol],
        queryFn: () => AssetService.getAssetInfo(symbol as string),
        enabled: !!symbol && !!user,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 2
    });

    return query;
}